module.exports = __webpack_public_path__ + "img/out_hub_logo.2e0dc222.svg";